import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sticker_b2s_1.svg'
import _imports_1 from '@/assets/sticker_b2s_2.svg'


const _withScopeId = n => (_pushScopeId("data-v-08567ea5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"back2school\" data-v-08567ea5><div class=\"contain_wrap back2school_wrap\" data-v-08567ea5><div class=\"txt\" data-v-08567ea5><h1 data-animation=\"paragraph\" data-v-08567ea5>Crocs Back <br data-v-08567ea5>To School</h1><p data-animation=\"paragraph\" data-v-08567ea5>Get the best Discount on our back to school deals</p><div class=\"btn\" data-v-08567ea5><button data-v-08567ea5>Shop Crocs</button></div></div><div class=\"img\" data-v-08567ea5><img data-sticker class=\"sticker_1 animate__animated\" src=\"" + _imports_0 + "\" alt=\"\" data-v-08567ea5><img data-sticker class=\"sticker_2 animate__animated\" src=\"" + _imports_1 + "\" alt=\"\" data-v-08567ea5><img src=\"https://res.cloudinary.com/dszdgdeoh/image/upload/v1663859493/b2s_jlezwr.svg\" alt=\"\" data-v-08567ea5></div></div></section>", 1)
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"span_slider\" data-v-08567ea5><h1 class=\"span_slider_wrap\" data-v-08567ea5><div class=\"_p span_slider_wrap_txt\" data-v-08567ea5>Join Crocs Fun Club  </div><div class=\"_g span_slider_wrap_txt\" data-v-08567ea5>Join Crocs Fun Club  </div><div class=\"_a span_slider_wrap_txt\" data-v-08567ea5>Join Crocs Fun Club  </div></h1><h1 class=\"span_slider_wrap\" data-v-08567ea5><div class=\"_p span_slider_wrap_txt\" data-v-08567ea5>Join Crocs Fun Club  </div><div class=\"_g span_slider_wrap_txt\" data-v-08567ea5>Join Crocs Fun Club  </div><div class=\"_a span_slider_wrap_txt\" data-v-08567ea5>Join Crocs Fun Club  </div></h1></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

import { IO } from "@/animations/observe";
import { onMounted } from "@vue/runtime-core";


export default /*#__PURE__*/_defineComponent({
  __name: 'b2school',
  setup(__props) {

onMounted(() => {
     const elem = document.querySelectorAll(".back2school .img [data-sticker]");

     elem.forEach((item) => {
          IO(item).then(() => {
               item.classList.toggle("animate__jackInTheBox");
          });
     });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "marquee",
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.dispatch('pauseMarquee'))),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.dispatch('playMarquee')))
    }, _hoisted_3, 32)
  ], 64))
}
}

})